// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.white};
  z-index: ${({ theme }) => theme.zIndex.under};
`;
